import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientCatheter, PatientCatheterData } from '../../../interfaces/masters/patient-catheter';
import { PatientCatheterApi } from '../api/patient-catheter.api';

@Injectable()
export class PatientCatheterService extends PatientCatheterData {

  constructor(private api: PatientCatheterApi) { 
    super();  
  }
  list(url: string): Observable<PatientCatheter[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PatientCatheter>{
      return this.api.getById(url); 
  }

  create(url: string, data:PatientCatheter): Observable<PatientCatheter> {
    return this.api.add(url,data);
  }

  update(url: string, data:PatientCatheter): Observable<PatientCatheter> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
